import React, { Component } from 'react';

class Contact extends Component {
    render() {
        return (
            <div>
               Contact pagexs
            </div>
        );
    }
}

export default Contact;